import { getDeviceId } from './device';
import { connect, disconnect } from './ws';

// With WebSocket transport the session lives on the connection, not in a stored
// token. `getToken()` returns a sentinel ('ws') while authenticated so the many
// `enabled: !!token` / `if (token)` gates across the app keep working unchanged.
const SENTINEL = 'ws';
let cached: string | null = null;

export function getToken(): string | null {
  return cached;
}

/** Logout when set to null → tears down the WebSocket. */
export function setToken(t: string | null) {
  cached = t;
  if (!t) disconnect();
}

/** Open + authenticate the WebSocket on app open (real Telegram only). Resolves
 *  to the sentinel token once the connection is authenticated. */
export async function bootstrapSession(
  initData: string,
  platform?: string,
  label?: string,
): Promise<string> {
  // The invite code rides along with the handshake: the server claims it only
  // for a user who has no referrer yet, so sending it on every reconnect is
  // harmless and means a link never goes to waste for want of a round-trip.
  const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
  await connect({ initData, deviceId: getDeviceId(), platform, label, startParam });
  cached = SENTINEL;
  return SENTINEL;
}
